import React from 'react'

const Users = () => (
  <svg
    width='16px'
    height='15px'
    viewBox='0 0 16 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xlink='http://www.w3.org/1999/xlink'>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        id='Artboard'
        transform='translate(-291.000000, -572.000000)'
        fill='#607D8B'
        fillRule='nonzero'>
        <g id='users' transform='translate(291.000000, 572.000000)'>
          <path
            d='M8.42661749,0.698939402 C8.92715259,0.26249168 9.57069832,4.26325641e-14 10.2727713,4.26325641e-14 C11.867914,4.26325641e-14 13.1609273,1.35503348 13.1609273,3.0266881 C13.1609273,4.69830863 11.867914,6.0533762 10.2727713,6.0533762 C9.57069534,6.0533762 8.92714713,5.7908823 8.42661113,5.35443125 C9.06331878,4.79924371 9.46861959,3.96257837 9.46861959,3.0266881 C9.46861959,2.09078185 9.06332148,1.25412126 8.42661749,0.698939403 Z M8.70360974,14.1170703 C10.3069802,13.8869853 11.2166328,13.4176744 11.2900176,13.3788629 L11.4832815,13.2760616 L11.503649,13.2762662 L11.503649,10.1347066 C11.503649,8.21981192 10.1710432,6.62467231 8.42667556,6.31437418 C8.62855473,6.27846528 8.83594951,6.259763 9.04743291,6.259763 L11.4982724,6.259763 C13.537076,6.259763 15.1959567,7.99821288 15.1959567,10.1347066 L15.1959567,13.2762662 L15.1755891,13.2760616 L14.9823253,13.3788629 C14.8847824,13.4304511 13.309747,14.2426324 10.5919821,14.2426324 C10.0132405,14.2426324 9.38271162,14.2058558 8.70360974,14.1170703 Z'
            id='Combined-Shape'
          />
          <path
            d='M2.03506194,3.0266881 C2.03506194,1.35503348 3.32807525,4.26325641e-14 4.92321789,4.26325641e-14 C6.51836053,4.26325641e-14 7.81137384,1.35503348 7.81137384,3.0266881 C7.81137384,4.69830863 6.51836053,6.0533762 4.92321789,6.0533762 C3.32807525,6.0533762 2.03506194,4.69834272 2.03506194,3.0266881 Z M6.14871899,6.259763 L3.69787947,6.259763 C1.65891321,6.259763 0,7.99821288 0,10.1347066 L0,13.2764708 L0.0076784968,13.3254676 L0.214607478,13.3931494 C2.16013034,14.03004 3.85096136,14.2426324 5.24242862,14.2426324 C7.96019352,14.2426324 9.53522891,13.4304511 9.63277184,13.3788629 L9.8260357,13.2760616 L9.84640324,13.2762662 L9.84640324,10.1347066 C9.84640324,7.99821288 8.18752257,6.259763 6.14871899,6.259763 Z'
            id='Shape'
          />
        </g>
      </g>
    </g>
  </svg>
)

export default Users
